/**
 * Load shader files (*.vert, *.frag)
 */

import * as THREE from "three";

export class ShaderLoader {
	private readonly manager: THREE.LoadingManager;

	constructor(manager,
							public path = null) {
		this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;
	};

	/**
	 * Sets resource root
	 * @param path
	 */
	setPath(path) {
		this.path = path;
	}

	/**
	 * Loads shader file
	 * @param url URL to be loaded
	 * @param onLoad onLoad callback
	 * @param onProgress onProgress callback
	 * @param onError onError callback
	 */
	load(url:string, onLoad, onProgress, onError) {
		let loader = new THREE.FileLoader(this.manager);
		if (this.path)
			loader.setPath(this.path);
		loader.load(url, function (text) {
			onLoad(text);
		}, onProgress, onError);
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/ShaderLoader.ts